import { z } from 'zod';

/**
 * Free medical category create/update form schema.
 * Used for validation in FreeMedicalCategoryEditModal.
 * Validates required fields and constraints from A2 backend.
 */
export const freeMedicalCategorySchema = z.object({
  category_name: z
    .string()
    .min(1, 'カテゴリ名は必須です')
    .max(255, 'カテゴリ名は255文字以下にしてください。'),
  product_sale_type_id: z
    .number({ invalid_type_error: '区分は必要です' })
    .int()
    .positive('区分は必要です'),
  sort_number: z
    .number({ invalid_type_error: '並び順は必須です。' })
    .int('並び順は整数である必要があります。')
    .positive('並び順を選択してください。'),
});

export type CategoryFormSchema = z.infer<typeof freeMedicalCategorySchema>;
